import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import Select from 'react-select'
import { useForm } from 'react-hook-form'
import { Table, Button } from 'react-bootstrap'
import axios from 'axios'
import StatusToggle from '../ui/StatusToggle'
import ConfirmModal from '../ui/ConfirmModal'

function BatchList() {
  const [data, setData] = useState([])
  const [assignedBatches, setAssignedBatches] = useState([])
  const [batches, setBatches] = useState([])
  const [testname, setTestName] = useState([])
  const [testcode, setTestCode] = useState([])
  const { id } = useParams()

  const navigate = useNavigate()
  const [unassignModalOpen, setUnassignModalOpen] = useState(false)
  const [batchToUnassign, setBatchToUnassign] = useState(null)

  useEffect(() => {
    getBatches(id)
  }, [])

  const getBatches = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}getactivebatches/${id}`
      )
      if (response.status === 200) {
        const batchData = response.data
        // Assuming batchData is an array, you can access the first element to get name and code
        if (batchData.length > 0) {
          const testdetails = batchData[0]
          setData(batchData)
          setTestCode(testdetails.testcode)
          setTestName(testdetails.testname)
        }
        setData(batchData)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const checkBatch = (item, e) => {
    console.log(item)
    let index = batches.indexOf(item)
    let batchesTemp = batches.slice()
    if (index > -1) {
      batchesTemp.splice(index, 1)
    } else {
      batchesTemp.push(item)
    }
    console.log(batchesTemp)
    setBatches(batchesTemp)
  }

  const handleSubmitAssign = async (e) => {
    e.preventDefault()
    if (batches.length === 0) {
      toast.error('Please choose batch')
    } else {
      let dataSend = {
        test_id: id,
        batches: batches,
      }
      console.log(dataSend)
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BASE_URL}assignbsattests`,
          dataSend,
          {
            withCredentials: true,
          }
        )

        if (data) {
          toast.success('Batch Assigned Successfully.')
          window.location.reload(true)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const unassignBatch = async (batchId) => {
    if (window.confirm('Are you sure you want to Unassign Batch?')) {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}unassignsattest/${id}/${batchId}`
      )
      toast.success(response.data)
      window.location.reload(true)
    }
  }

  // Map data for easier rendering
  const mappedData = data.map((item, index) => ({
    id: item._id,
    sNo: String(index + 1).padStart(2, '0'),
    batchName: item.batch_title,
    batchCode: item.batch_code,
    status: item.status === 1 ? 'Assigned' : 'Not Assigned',
    isActive: item.status === 1,
    isSelected: item.status === 1 || batches.includes(item._id),
    raw: item,
  }))

  // StatusBadge copied from ActTestList
  const StatusBadge = ({ status }) => {
    if (status === 'Not Assigned') {
      return (
        <div className="justify-center flex flex-col text-xs text-[#E90004] font-medium whitespace-nowrap text-center leading-none w-full px-2 py-1.5">
          <div className="bg-[rgba(233,0,4,0.10)] flex flex-col items-center justify-center px-2 py-1.5 rounded-[20px]">
            <div className="flex gap-1">
              <span className="flex items-center">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="7"
                    cy="7"
                    r="6.5"
                    fill="#fff"
                    stroke="#E90004"
                    strokeWidth="1"
                  />
                  <path
                    d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5"
                    stroke="#E90004"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              <div>Not Assigned</div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="justify-center flex flex-col text-xs text-[rgba(4,146,185,1)] font-medium whitespace-nowrap text-center leading-none w-full px-2 py-1.5">
        <div className="bg-[rgba(4,146,185,0.1)] flex flex-col items-center justify-center px-2 py-1.5 rounded-[20px]">
          <div className="flex gap-1">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/fa9cebe651f1f5ccad3b469ace21dc73ab8498b0?placeholderIfAbsent=true"
              className="aspect-[1] object-contain w-3.5 shrink-0"
              alt="Status icon"
            />
            <div>{status}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full mt-2.5 max-md:max-w-full">
      <div className="justify-between items-center border border-[color:var(--Stock,#F0F0F0)] flex w-full gap-[40px_100px] font-medium leading-[1.2] flex-wrap bg-white px-5 py-3.5 rounded-[10px_10px_0px_0px] border-solid max-md:max-w-full">
        <div className="text-[#030303] text-lg self-stretch my-auto">
          {testname} - {testcode}: Assign Batches
        </div>
        <div className="flex gap-2">
          <button
            className="justify-center items-stretch flex flex-col text-xs text-white text-center w-[100px] bg-[#DE3C7D] my-auto p-2.5 rounded-md hover:bg-[#c72c6a] transition-colors font-medium"
            type="button"
            onClick={() => navigate(-1)}
          >
            <div className="flex w-full gap-1">
              <div className="text-white">Back</div>
            </div>
          </button>
          <button
            className="justify-center items-stretch flex flex-col text-xs text-white text-center w-[150px] bg-[#DE3C7D] my-auto p-2.5 rounded-md hover:bg-[#c72c6a] transition-colors font-medium"
            type="submit"
            onClick={handleSubmitAssign}
          >
            <div className="flex w-full gap-1">
              <div className="text-white">Assign Batches</div>
            </div>
          </button>
        </div>
      </div>
      {/* Table Header */}
      <div className="flex w-full bg-neutral-50 border-b border-l border-r border-[#F0F0F0]">
        <div className="w-20 flex-none px-4 py-3.5 border-r border-[#F0F0F0]"></div>
        <div className="w-32 flex-none px-4 py-3.5 border-r border-[#F0F0F0] text-center">
          S.No
        </div>
        <div className="w-80 flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          Batch Name
        </div>
        <div className="w-60 flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          Batch Code
        </div>
        <div className="w-80 flex-none px-4 py-3.5 border-r border-[#F0F0F0] text-center">
          Status
        </div>
        <div className="w-20 flex-none px-4 py-3.5 text-center">Action</div>
      </div>
      {/* Table Rows */}
      {mappedData.length > 0 ? (
        mappedData.map((item, index) => (
          <div
            key={item.id}
            className={`flex w-full border-b border-l border-r border-[#F0F0F0] bg-white ${
              index === mappedData.length - 1 ? 'rounded-b-[10px]' : ''
            }`}
          >
            <div className="w-20 flex-none px-4 py-2 border-r border-[#F0F0F0] flex items-center justify-center">
              <label className="cursor-pointer">
                <input
                  type="checkbox"
                  checked={item.isSelected}
                  onChange={(e) => checkBatch(item.id, e)}
                  className="sr-only"
                />
                <span className="inline-block w-4 h-4">
                  {item.isSelected ? (
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/ef7fcf665d69a24f338a53eba4618a706e0d31d1?placeholderIfAbsent=true"
                      className="w-full h-full object-contain"
                      alt="Selected"
                    />
                  ) : (
                    <div className="w-full h-full border border-[color:var(--Text,#535862)] rounded-[3px] border-solid" />
                  )}
                </span>
              </label>
            </div>
            <div className="w-32 flex-none px-4 py-2 border-r border-[#F0F0F0] text-center">
              {item.sNo}
            </div>
            <div className="w-80 flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.batchName}
            </div>
            <div className="w-60 flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.batchCode}
            </div>
            <div className="w-80 flex-none px-4 py-2 border-r border-[#F0F0F0] flex items-center justify-center">
              <StatusBadge status={item.status} />
            </div>
            <div className="w-20 flex-none px-4 py-2 flex items-center justify-center">
              {item.isActive && (
                <StatusToggle
                  status={item.isActive}
                  onChange={() => {
                    setBatchToUnassign(item.id)
                    setUnassignModalOpen(true)
                  }}
                  disabled={!item.isActive}
                />
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-8 text-[#535862] text-sm border-x border-b border-[color:var(--Stock,#F0F0F0)] bg-white rounded-b-[10px]">
          No Data Available
        </div>
      )}
      {/* Unassign Confirm Modal */}
      {unassignModalOpen && (
        <ConfirmModal
          open={unassignModalOpen}
          onCancel={() => {
            setUnassignModalOpen(false)
            setBatchToUnassign(null)
          }}
          onConfirm={async () => {
            await unassignBatch(batchToUnassign)
            setUnassignModalOpen(false)
            setBatchToUnassign(null)
          }}
          title="Unassign Batch"
          message="Are you sure you want to unassign this batch?"
        />
      )}
    </div>
  )
}
export default BatchList
